<template>
  <section-container>
    <header-page
      title_header="Assinatura"
      sub_header="Informação da sua assinatura"
    />
    <content-e>
      <div class="w-full p-2 flex">
        <button-icon
          icon="cubes"
          :to="{ name: 'subscription.plan' }"
          text="Planos de Assinatura"
          class="bg-indigo-600"
        />
      </div>
      <div class="w-full p-2 overflow-x-auto">
        <table
          class="text-left w-full table-responsive bg-white shadow-2l rounded-lg"
        >
          <thead>
            <tr>
              <th
                class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
              >
                Total
              </th>
              <th
                class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
              >
                Status
              </th>
              <th
                class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-grey-light"
              >
                Data do pedido
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in charges" :key="item.id">
              <td
                class="border-dashed border-t border-gray-200 px-3 text-sm py-3"
              >
                {{ item.total }}
              </td>
              <td class="border-dashed border-t border-gray-200 px-3 text-sm">
                <span
                  class="rounded-lg relative inline-block px-3 py-1 font-bold leading-tight"
                  :class="`status-${item.status}`"
                >
                  <span class="relative">{{
                    item.status === 'paid' ? 'Pago' : 'Aguardando Pagamento'
                  }}</span>
                </span>
              </td>
              <td class="border-dashed border-t border-gray-200 px-3 text-sm">
                {{ item.date | moment('DD/MM/YYYY HH:mm') }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </content-e>
  </section-container>
</template>

<script>
export default {
  computed: {
    subscriptionActive() {
      return this.$store.state.subscription
    }
  },
  data() {
    return {
      subscription: null,
      charges: {}
    }
  },
  async beforeMount() {},
  async mounted() {
    this.$store.dispatch('MY_SUBSCRIPTION_HISTORY').then((response) => {
      this.subscription = response
      this.charges = response
    })
  }
}
</script>

<style>
</style>
